export default "__VITE_ASSET__fdH$cqB9__"